var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0944 29.1087L37.2376 37.3109M33.4741 18.4934C33.4741 26.8075 26.7343 33.5474 18.4202 33.5474C10.1061 33.5474 3.36621 26.8075 3.36621 18.4934C3.36621 10.1793 10.1061 3.43945 18.4202 3.43945C26.7343 3.43945 33.4741 10.1793 33.4741 18.4934Z",
    stroke: "#6E5777",
    strokeWidth: 5.37641,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search1.2152a3488a05ac1cfe6c9dc476d5b871.svg";
export { ForwardRef as ReactComponent };